import { AxiosResponse } from "axios";
import BaseAPI from "../api";

const path:string = "activity-category";


export class ActivityCategoryApi extends BaseAPI{

    static dropdownList():Promise<AxiosResponse>{
        return this.api.get(`${path}/dropdown`)
    }
}